<div class="error-center">
    <div class="ot-pt-3 ot-pb-2">
        <img alt="Page not found" alt-i18n src="./assets/icons/ill_server_error220.svg">
    </div>
    <div class="ot-pb-1">
        <h1 i18n class="error-title">
            Page not found
        </h1>
    </div>
    <div class="ot-pb-2">
        <h4 i18n class="error-message">
            Oops! The page you are looking for does not exist
        </h4>
    </div>
    <div>
        <button role="button" title="Home" title-i18n class="ot-btn ot-btn--is-primary" [routerLink]="['/home']">
            Home
        </button>
    </div>
</div>